<template>
  <nav class="flex flex-wrap max-w-7xl mx-auto" aria-label="Breadcrumb">
    <ol role="list" class="flex items-center space-x-2 sm:space-x-4 truncate">
      <!-- Home Route -->
      <li>
        <router-link :to="'/'" class="text-gray-400 hover:text-gray-500">
          <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true"/>
          <span class="sr-only">Home</span>
        </router-link>
      </li>

      <!-- Pages Routes -->
      <li v-for="page in pages" :key="page">
        <div class="flex items-center space-x-2 sm:space-x-6">
          <ChevronRightIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true"/>
          <router-link v-if="!page.current && page.href" :to="page.href" class="text-sm font-semibold text-gray-500 hover:text-gray-700"
             :aria-current="page.current ? 'page' : undefined">
             {{ page.name }}
          </router-link>
          <p v-else class="text-sm font-light text-gray-500 max-w-md truncate">
            {{ page.name }}
          </p>
        </div>
      </li>
    </ol>
  </nav>

</template>

<script setup>
import {ChevronRightIcon, HomeIcon} from '@heroicons/vue/solid'

const prop = defineProps(['pages']);
</script>
